// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"66d0b607c696fb79","2606":"66d0b607c696fb79","2888":"6812091d5cb2c02a","3077":"66d0b607c696fb79","8220":"5127ebc978e83226"}[chunkId] + ".css";
};